[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 13,
                "y": 22,
                "key": "tLpRoiW2EvVrLyND4pBYF"
            },
            {
                "x": 17,
                "y": 22,
                "key": "7gTwWqlCkIq9wxOI9wDMl"
            },
            {
                "x": 17,
                "y": 26,
                "key": "z9Nn61pWmpd489F0Co-yj"
            },
            {
                "x": 13,
                "y": 26,
                "key": "stOEn_4Hof8z7g2cDFKPY"
            }
        ]
    }
]